import { useTranslation } from "react-i18next";
import { useFetch } from "../../../../hooks/api";
import { Row, Col, Table } from "react-bootstrap";
import moment from "moment";
import Loading from "../../../core/blocks/Loading";
import { formatCurrency } from "../../../../utils/formatNumber";
import { useAppSelector } from "../../../../redux/hooks";

const BudgetProgramLog = ({ advertisementId }) => {
  const { t } = useTranslation(["programs"]);
  const logQueryFilters = {
    advertisement: advertisementId,
    only_action: true,
  };

  const { marketPlace } = useAppSelector((state) => state.marketPlace);

  const { data, isLoading } = useFetch(
    ["program_logs_advertisement_budgets", advertisementId],
    `/programlogs/advertisement_budgets/`,
    logQueryFilters,
    { select: (data) => data?.data?.results ?? [] },
  );
  const captalize = (str) => {
    if (!str) return null;
    str = str.toLowerCase().replaceAll("_", " ");
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <>
      <Row className="pt-5">
        <Col>
          <div className="pb-3">
            <span className="fs-4 fw-bold">{t(($) => $.programs.log["Rule Logs"])}</span>
          </div>
        </Col>
      </Row>
      <Row className="pb-3">
        <Col>
          {isLoading && <Loading height={"300px"} fullPage={false} />}
          {!isLoading && (
            <Table striped bordered>
              <thead>
                <tr>
                  <th>{t(($) => $.programs.log.Time)}</th>
                  <th>{t(($) => $.programs.log.Program)}</th>
                  <th>{t(($) => $.programs.log.Action)}</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((log, i) => {
                  return (
                    <tr key={i}>
                      <td>{moment(log.ts).format("YYYY-MM-DD HH:mm:ss")}</td>
                      <td>
                        {log?.program?.name} ({log?.program?.id})
                      </td>
                      <td>
                        <span>{log?.action?.length === 0 && t(($) => $.programs.log["N/A"])}</span>
                        {log?.action?.map((action, i) => {
                          const placementLabelMap = {
                            PLACEMENT_TOP: t(($) => $.programs.placement["Top of Search"]),
                            PLACEMENT_REST_OF_SEARCH: t(($) => $.programs.placement["Rest of Search"]),
                            PLACEMENT_PRODUCT_PAGE: t(($) => $.programs.placement["Detail Page"]),
                          };
                          return (
                            <div key={i} style={{ marginBottom: "5px" }}>
                              <span className="fw-bold">{captalize(action?.function)}</span>
                              :&nbsp;
                              {action?.next_budget && (
                                <span className="fw-light">
                                  {t(($) => $.programs.log["New: {next} - Prev: {prev}"], {
                                    next: formatCurrency(action?.next_budget, {
                                      marketPlace: marketPlace,
                                    }),
                                    prev: formatCurrency(action?.current_budget, {
                                      marketPlace: marketPlace,
                                    }),
                                  })}
                                </span>
                              )}
                              {action?.next_percentage && (
                                <>
                                  {action?.placement && (
                                    <>
                                      <span className="fw-light">
                                        {placementLabelMap[action?.placement] ?? action?.placement}
                                      </span>
                                      <span>, &nbsp;</span>
                                    </>
                                  )}
                                  <span className="fw-light">
                                    {t(($) => $.programs.log["New: {next}% - Prev: {prev}%"], {
                                      next: action?.next_percentage,
                                      prev: action?.current_percentage,
                                    })}
                                  </span>
                                </>
                              )}
                            </div>
                          );
                        })}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </Col>
      </Row>
    </>
  );
};

export default BudgetProgramLog;
